import { render } from "./HeaderComponent.vue?vue&type=template&id=6d023a20"
import script from "./HeaderComponent.vue?vue&type=script&lang=js"
export * from "./HeaderComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/checkout/payment/HeaderComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d023a20"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d023a20', __exports__)) {
    api.reload('6d023a20', __exports__)
  }
  
  module.hot.accept("./HeaderComponent.vue?vue&type=template&id=6d023a20", () => {
    api.rerender('6d023a20', render)
  })

}


export default __exports__